import React, {FunctionComponent, useEffect, useState} from "react"
import CrisisFiles from "./components/CrisisFiles"
import Dashboards from "../DashboardAdmin"
import TabPanel, {TabType} from "@murphy-frontend/web-core/components/Tabs/TabPanel"
import {useModal} from "@murphy-frontend/web-core/contexts/ModalContext"
import {useUserPreferences} from "../../common/contexts/UserPreferencesContext"
import useWindowDimensions from "@murphy-frontend/web-core/hooks/useWindowDimensions"
import ComponentWrapper from "../../common/components/ComponentWrapper"
import CrisisDashboards from "../DashboardAdmin/CrisisDashboards"

const CrisisPortal: FunctionComponent = () => {
	const {openModal, closeModal} = useModal()
	const {translations, timeZone, language} = useUserPreferences()
	const {currentSize,width, height} = useWindowDimensions();

	return (
		<ComponentWrapper active={5}>
			<div className='pbs-grid'>
			<CrisisDashboards
				spawnModal={openModal}
				translations={translations}
				language={language}
				currentScreenSize={currentSize}
				currentwidth = {width}
				timeZone={timeZone}
			/>
			</div>
		</ComponentWrapper>
	)
}

export default CrisisPortal
